import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { ASSUMPTIONS_TABS } from 'Consts/facet-plan';
import { FDPrimaryActionButton, FDStack } from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { dataAttrs } from 'Helpers/Testing';
import SidebarSubtitle from '../Content/SidebarSubtitle';
import metaOverrideSet from './AssumptionsOverrideFD';

const AssumptionsLayout = ({ canSubmit, loading }) => {
  const { resource, onSubmit, saving } = useMetaLayoutContext();
  if (!resource) {
    return null;
  }

  const resourceAttrNames = Object.keys(resource.attributes());
  const filteredTabs = ASSUMPTIONS_TABS.filter(t => t.fields && t.fields.length > 0 && resourceAttrNames.some(attrName => t.fields.includes(attrName)));

  return (
    <FDStack direction={'column'}>
      {filteredTabs.map(tab => (
        <FDStack key={tab.key} direction={'column'} paddingY={2}>
          <SidebarSubtitle title={tab.label} />
          <FDStack direction={'column'} spacing={1} flex={1}>
            {tab.fields.map(field => <MetaControlField key={field} attr={field} />)}
          </FDStack>
        </FDStack>
      ))}
      {canSubmit && (
      <FDPrimaryActionButton
        onClick={onSubmit}
        label="Submit"
        loading={saving || loading}
        {...dataAttrs('assumptions-submit-btn')}
      />
      )}
    </FDStack>
  );
};

const Assumptions = () => {
  const { resource } = useMetaLayoutContext();
  const { displaySuccess, displayErrorMessage } = useSnackbarContext();
  const { refreshPageContentCollection } = usePageContentContext();

  const [loading, setLoading] = React.useState(false);
  const canSubmit = resource.meta().canSubmit();

  async function handleSubmit() {
    try {
      setLoading(true);
      displaySuccess('Assumptions saved');
      await refreshPageContentCollection();
    } catch (err) {
      displayErrorMessage(err, err.errors);
    } finally {
      setLoading(false);
    }
  }

  return (
    <MetaResourceRenderer
      layout={AssumptionsLayout}
      resource={resource.attr('allocations').resources().head()}
      metaOverrideSet={metaOverrideSet}
      onSubmit={handleSubmit}
      LayoutProps={{ canSubmit, loading }}
    />
  );
};

Assumptions.defaultProps = {};
Assumptions.propTypes = {};

export default Assumptions;
